import { inject, Injectable } from '@angular/core';
import { MSAL_TOKEN, TOKEN } from '../constants/sessionstorage.constants';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CombinedStore } from 'src/app/core/combined.store';
import { CANAL_VENTE_C } from '../constants/context.constants';

@Injectable()
export class AuthBearerInterceptor implements HttpInterceptor {
  private store = inject(CombinedStore);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token;

    if (this.store.context().canalVente == CANAL_VENTE_C) {
      token = JSON.parse(sessionStorage.getItem(MSAL_TOKEN) ?? '""');
    } else {
      token = JSON.parse(sessionStorage.getItem(TOKEN) ?? '""');
    }

    // Si un token est présent, ajouter l'en-tête Authorization
    if (req.url.includes('/members') && token) {
      const clonedRequest = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

      return next.handle(clonedRequest);
    }

    // Si pas de token, continuer avec la requête originale
    return next.handle(req);
  }
}
